module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAWCAYAAAChWZ5EAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEpSURBVHgB7ZVPTsJQEMa/11JQpCDGVIqJiSt3bjyBB9AD6NoLEF0bPYB7j+ApdK9rE7YEaFjAhlIg5d+bSeiCP0kXExqSfkkzTV7S+c03M33qP389R4IykLD2A8CqWjh5ONYxA2nFAji4yqH8WGaQnQKU7myO/W8frVobwd8Q+ZtDGLZc57Z+qXRfhPPiRMlG9TFM/e6+V3D2fAopqdU1JLsrbw6y1SwnD9shJ2/VPD4v3B5BgVwZQEJrDlAy/yeIKqe+dz970bmvE0sl3whACn4DjrP+DFP9EBSJWnD+4bILUtq4V0bRQOOpqe2f8CyQG0sY0zZhFuSGUMX5FVPlGddC6IUMIqlYpeT0YF5+XfCASisWAO2/99qJZkFSKr0NkbBSgBQgcYAF5QFYUnGNWVkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh.png
// module id = PD15
// module chunks = 1